import { jsxs as i, jsx as t } from "react/jsx-runtime";
import { Ratings as d } from "../Ratings/index.js";
import { CountBox as m } from "../Countbox/index.js";
import { getRatingLabel as c } from "../../utils/rating.js";
import { SimplyReviewFlat as a } from "../Logos/SimplyReviewFlat.js";
function x({
  rating: n,
  reviewCount: l,
  slug: r,
  textColor: s
}) {
  const e = s || "#212b36";
  return /* @__PURE__ */ i("div", { style: o.wrapper, children: [
    /* @__PURE__ */ i("div", { style: { display: "flex", alignItems: "center" }, children: [
      /* @__PURE__ */ t(m, { rating: n, backgroundColor: e }),
      /* @__PURE__ */ t("div", { style: { marginRight: 8 } }),
      /* @__PURE__ */ t("div", { style: { ...o.text, color: e }, children: c(n) }),
      /* @__PURE__ */ t("div", { style: { marginRight: 8 } }),
      /* @__PURE__ */ t("div", { style: { display: "flex" }, children: /* @__PURE__ */ t(d, { rating: n }) }),
      /* @__PURE__ */ t("div", { style: { marginRight: 8 } })
    ] }),
    /* @__PURE__ */ i(
      "div",
      {
        style: {
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          opacity: 0.5
        },
        children: [
          /* @__PURE__ */ i(
            "div",
            {
              style: {
                ...o.text,
                fontSize: 12,
                fontWeight: 400,
                color: e,
                textAlign: "center"
              },
              children: [
                l,
                " reviews on"
              ]
            }
          ),
          /* @__PURE__ */ t("div", { style: { marginRight: 8 } }),
          /* @__PURE__ */ t(
            a,
            {
              width: 80,
              style: { width: 80, marginBottom: -6 },
              slug: r,
              color: e
            }
          )
        ]
      }
    )
  ] });
}
const o = {
  wrapper: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    flexDirection: "column",
    // border: '1px solid #f4f4f5',
    padding: "8px"
  },
  text: {
    fontFamily: "inherit",
    fontSize: "18px",
    fontWeight: "bold",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "normal",
    letterSpacing: "-0.24px"
    /* color: #1f1f1f; */
  }
};
export {
  x as CompactReviewCount
};
